const dashboard = {
  root: "Tableau de bord",
};
export default dashboard;
